export function Logo({ compact = false }: { compact?: boolean }) {
  return (
    <span className="inline-flex items-center" data-testid="eve-logo">
      <img
        src="/assets/logo/eve-logo.png"
        alt="EVE — official logo"
        className={compact ? "h-8 w-auto" : "h-10 w-auto sm:h-12"}
      />
    </span>
  );
}
